module.exports = __webpack_public_path__ + "static/img/gray.71d429d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gray.png
// module id = rxGg
// module chunks = 1